'use es6';

import keyMirror from 'react-utils/keyMirror';
export const PREVIEW_DEVICES = Object.freeze(keyMirror({
  RESPONSIVE: null,
  CUSTOM: null,
  MOBILE: null,
  TABLET: null
  /* We can add specific devices as well */

}));
export const PREVIEW_DEVICE_FRAMES = Object.freeze({
  MOBILE: 'mobile',
  TABLET: 'tablet'
});
export const ZOOM_PRESETS = Object.freeze(keyMirror({
  FIT: null,
  50: null,
  75: null,
  100: null,
  125: null,
  150: null
}));
export const ZOOM_PRESETS_ORDER = [ZOOM_PRESETS['50'], ZOOM_PRESETS['75'], ZOOM_PRESETS['100'], ZOOM_PRESETS['125'], ZOOM_PRESETS['150'], ZOOM_PRESETS.FIT];
export const PREVIEW_DEVICES_ORDER = [PREVIEW_DEVICES.RESPONSIVE, PREVIEW_DEVICES.CUSTOM, PREVIEW_DEVICES.MOBILE, PREVIEW_DEVICES.TABLET];